export default [
    {
        img:  require('../assets/imgs/home/home-solution-shiyou.png'),
        desc: '运用高分遥感、无人机、北斗导航等技术构建对油气管道的空天地一体化监测预警体系',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-shengtai.png'),
        desc: '“全过程”咨询服务，“空天地一体化”监测服务，“精准化”智慧管控平台支撑服务',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-ziran.png'),
        desc: '面向耕地资源、森林资源、水资源、湿地资源等自然资源，提供快速变化和检测和自然资源综合变化监测服务，满足自然资源部门常规监测、专题监测、应急监测和动态监测的需求',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-huoqing.png'),
        desc: '慧眼知火-航天宏图防火智慧监管SaaS服务，融合卫星遥感、地面监控、航空巡查、人工巡检等多重手段，精准锚定我国防灭火痛点',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-zhihui.png'),
        desc: '城市治理的精准分析、整体研判、协同指挥、科学治理，实现治理体系与治理能力现代化水平的显著提升，促进“决策科学化”、“治理精准化”、“服务高效化”',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-shuzi.png'),
        desc: '数据基础设施、公共支撑平台、乡村数字经济、智慧绿色乡村、乡村数字治理、乡村网络文化、信息惠民等多个应用场景，助力数字乡村建设发展',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-haiyang.png'),
        desc: '空天地海潜多源异构数据标准化，海洋大数据深度分析和智能应用，海洋综合立体环境监测和预报服务，数据接收-管理-处理-应用-透明可视化及共享分发全流程',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-shuili.png'),
        desc: '一套水土保持智能感知体系、一个水土保持数据中心和一个水土保持业务信息管理平台，为水土保持核心业务提供从信息采集到数据处理、分析评价和信息发布的全方位、全流程服务',
        toUrl: ''
    }, {
        img: require('../assets/imgs/home/home-solution-qixiang.png'),
        desc: '引接气象系统业务数据，面向行业用户与公众提供定制化的高时空分辨率、高精度的智慧气象服务产品',
        toUrl: ''
    }
]